import { render, staticRenderFns } from "./CourseRecommend.vue?vue&type=template&id=55626b80&scoped=true&"
import script from "./CourseRecommend.vue?vue&type=script&lang=js&"
export * from "./CourseRecommend.vue?vue&type=script&lang=js&"
import style0 from "./CourseRecommend.vue?vue&type=style&index=0&id=55626b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55626b80",
  null
  
)

export default component.exports